const attackSpeeds = {
    3: "매우빠름",
    4: "빠름",
    5: "보통",
    6: "느림",
    7: "매우느림"
};

export default attackSpeeds;